var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInputInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "info-circle-fill",
    d: "M8,16A8,8,0,1,0,0,8,8,8,0,0,0,8,16Zm.93-9.412-1,4.7c-.07.34.029.533.3.533a1.106,1.106,0,0,0,.686-.246L8.832,12a2.071,2.071,0,0,1-1.465.6c-.7,0-1-.422-.808-1.319L7.3,7.807c.064-.293.006-.4-.287-.47l-.451-.081.082-.381,2.29-.287ZM8,5.5a1,1,0,1,1,1-1A1,1,0,0,1,8,5.5Z",
    fill: "#abb8c3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputInfoIcon);
export default __webpack_public_path__ + "static/media/InputInfoIcon.4c54f9307bbe6e0cf99288026e759490.svg";
export { ForwardRef as ReactComponent };